module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1782880901430.png";